import PageState from "./state"
import mutations from "./mutations"
import APIS from "./apis"
import {getModule} from '@/store/store'

export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"order"
  })
}